import { clearUnitReport } from "./unitReportActions";

const SELECT_REPORT = "SELECT_REPORT";
const CLEAR_SELECTED_REPORTS = "CLEAR_SELECTED_REPORTS";

const selectReportAction = (data) => {
  return {
    type: SELECT_REPORT,
    data,
  };
};

const selectReport = (data) => {
  return (dispatch) => {
    dispatch(clearUnitReport());
    dispatch(selectReportAction(data));
  };
};

const clearSelectedReportsAction = () => {
  return {
    type: CLEAR_SELECTED_REPORTS,
  };
};

export { SELECT_REPORT, selectReportAction, selectReport, CLEAR_SELECTED_REPORTS, clearSelectedReportsAction };
